import React, { Component } from 'react';
import { Box, Flex, Text } from 'core/components';
import styled from 'styled-components';
import Markdown from 'app/components/markdown/Markdown';
import ToolResultCard from '../components/ToolResultCard';

// reduce some of the margins of headings for tool debug
const ToolMarkdownWrap = styled(Box)`
  h3,
  h4 {
    margin-top: 0;
  }
`;

class DefaultToolResult extends Component {
  render() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    const { processed_result } = tool;

    let markdownContent = null;
    try {
      if (processed_result) {
        markdownContent = (
          <ToolMarkdownWrap>
            <Markdown>{processed_result}</Markdown>
          </ToolMarkdownWrap>
        );
      }
    } catch (e) {
      markdownContent = null;
    }

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        className="tool-result-default"
        title={tool.title || 'Tool Result'}
        isInlineMode={isInlineMode}
      >
        <Flex key={tool.id || tool.tool_tracking_id} flexDirection="column" gap={2} p={1}>
          {markdownContent || (
            <Text>Tool result not implemented for tool: {tool.tool_display_name || tool.tool_name}</Text>
          )}
        </Flex>
      </ToolResultCard>
    );
  }
}

export default DefaultToolResult;
